import { render, staticRenderFns } from "./slot-duration-selector.vue?vue&type=template&id=dd4b0cee&"
import script from "./slot-duration-selector.vue?vue&type=script&lang=ts&"
export * from "./slot-duration-selector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports